export default {
  analytics: {
    cookie: ["_ga", "_ga_<container-id>"],
  },
};
